export const iconFontAwesomeHandsHandPeace = (
	<i className="fa-solid fa-hand-peace"></i>
);
